import { useEffect, useState } from 'react';
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  IconButton,
  Grid,
  Paper,
  Stack
} from '@mui/material';
import { Close, CloudUpload } from '@mui/icons-material';
import { useSelector } from 'react-redux';

const CreateOrganisationModel = ({ open, handleClose, addOrganisation }) => {
    const [formData, setFormData] = useState({
    organisation_name: '',
    partner_name: '',
    agreement_doc: null,
  });

  const { loading, data, error } = useSelector((state) => state.addOrganisation || {});
const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    
    if (type === 'file' && files) {
      setFormData(prev => ({
        ...prev,
        [name]: files[0],
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  

  const handleSubmit = () => {
    if (
      formData.organisation_name.trim() &&
      formData.partner_name.trim() &&
      formData.agreement_doc
    ) {
      addOrganisation(formData);
      // setFormData({
      //   organisation_name: '',
      //   partner_name: '',
      //   company_admin_name: '',
      //   agreement_doc: null,
      // });
    }
  };

   const handleModalClose = () => {
    handleClose(); // Close modal
    // Reset form data when modal closes
    setFormData({
      organisation_name: '',
      partner_name: '',
      agreement_doc: null,
    });
  };
  useEffect(()=>{
    setFormData({
      organisation_name: '',
      partner_name: '',
      company_admin_name: '',
      agreement_doc: null,
    });
  },[open])

  return (
      <Modal
      open={open}
      onClose={handleModalClose}
      aria-labelledby="modal-title"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2
      }}
    >
      <Box sx={{
        width: '100%',
        maxWidth: 800,
        bgcolor: 'background.paper',
        borderRadius: 2,
        boxShadow: 24,
        p: 2,
        outline: 'none'
      }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Typography variant="h5" component="h2" id="modal-title">
            Add Organisation
          </Typography>
          <IconButton onClick={handleClose} size="small">
            <Close />
          </IconButton>
        </Box>

        <Box sx={{ height: 2, bgcolor: 'error.main', mb: 4 }} />

        <Stack spacing={3}>
          <Grid direction={"column"}>
            <Grid item xs={12} md={4} pb={3}>
              <TextField
                fullWidth
                label="Organisation Name"
                name="organisation_name"
                value={formData.organisation_name}
                onChange={handleChange}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Partner Name"
                name="partner_name"
                value={formData.partner_name}
                onChange={handleChange}
                variant="outlined"
              />
            </Grid>
          </Grid>

          <Paper
            variant="outlined"
            sx={{
              p: 3,
              textAlign: 'center',
              cursor: 'pointer',
              '&:hover': {
                borderColor: 'error.main'
              }
            }}
          >
            <input
              type="file"
              name="agreement_doc"
              onChange={handleChange}
              accept=".pdf,.doc,.docx"
              style={{ display: 'none' }}
              id="agreement-doc-input"
            />
            <label htmlFor="agreement-doc-input">
              <Stack spacing={1} alignItems="center">
                <CloudUpload color="action" sx={{ fontSize: 40 }} />
                <Typography variant="body2" color="text.secondary">
                  {formData.agreement_doc
                    ? formData.agreement_doc.name
                    : 'Click to upload Agreement Document'}
                </Typography>
              </Stack>
            </label>
          </Paper>

          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
            <Button
              variant="contained"
              color="error"
              onClick={handleSubmit}
              disabled={
                !formData.organisation_name.trim() ||
                !formData.partner_name.trim() ||
                !formData.agreement_doc || loading
              }
            >
              {loading ? "Adding...":"Add Organisation"}
            </Button>
          </Box>
        </Stack>
      </Box>
    </Modal>
  )
}
export default CreateOrganisationModel